var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHostinger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00025 15.046V1.0005L10.0892 4.78046V11.1086L19.4735 11.1132L26.6774 15.046H3.00025ZM21.3925 9.95058V1L28.6725 4.6859V14.1797L21.3925 9.95058ZM21.3924 27.1177V20.8441L11.9358 20.8375C11.9446 20.8793 4.6123 16.8418 4.6123 16.8418L28.6725 16.9547V31L21.3924 27.1177ZM3 27.1177L3.00025 17.9393L10.0892 22.0683V30.8033L3 27.1177Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostinger);
export default __webpack_public_path__ + "static/media/hostinger.4a0cd89959eb9e3228aa62082c668736.svg";
export { ForwardRef as ReactComponent };